<!-- ChatWidget.vue -->
<template>
  <div id="blip-chat-widget" />
</template>

<script>
export default {
  name: 'ChatWidget',
  mounted() {
    const script = document.createElement('script')
    script.src = 'https://unpkg.com/blip-chat-widget'
    script.async = true
    script.onload = this.initializeBlipChat
    document.body.appendChild(script)
  },
  methods: {
    initializeBlipChat() {
      new BlipChat()
        .withAppKey('bGFyYTIzOjc0MGRjM2M4LTE5NmYtNDNiYS1hYjlhLWJiNTMxYzc2ODQwMw==')
        .withButton({ color: '#B74C3B', icon: '' })
        .withCustomCommonUrl('https://edvomberto-d6198.chat.blip.ai/')
        .build()
    },
  },
}
</script>
